module.exports = __webpack_public_path__ + "static/media/logo.107a63f7.png";